import React, { Component } from 'react';

// Services
import { currency, currencyNameToSymbol } from 'services/currency';
import { dateWithTimezone } from 'src/services/date';
import {
  getTransactionsList,
  translateTransactionStatus,
  translatePayMethod,
  highlightCellFromStatus
} from './PaymentsTabServices';

// components
import PaymentsEmptyTab from './PaymentsEmptyTab';

// Styles
import styles from './styles';

const headerCellsTranslateList = ['payment_id', 'amount', 'payment_method', 'date_time', 'status'];

class PaymentsTab extends Component {
  constructor() {
    super();
    this.state = {
      transactionsList: []
    };
  }

  componentWillMount() {
    const { appointmentId } = this.props;
    if (appointmentId)
      getTransactionsList(appointmentId)
        .then(transactionsList => {
          this.setState({ transactionsList });
        })
        .catch(() => {
          this.setState({ transactionsList: [] });
        });
  }

  render() {
    const { i18n } = this.props;
    const { transactionsList } = this.state;
    return transactionsList && transactionsList.length > 0 ? (
      <styles.Table>
        {/* ──── Header ──────────────────────────────────────────────────────────────────────── */}

        <thead>
          <styles.HeaderRow>
            {headerCellsTranslateList.map(cellName => (
              <th key={`header-cel-${cellName}`}>{i18n.t(cellName)}</th>
            ))}
          </styles.HeaderRow>
        </thead>

        {/* ──── Body ────────────────────────────────────────────────────────────────────────── */}
        <tbody>
          {transactionsList.map((item, index) => (
            <styles.BodyRow
              key={`body-row-${index.transactionId}-${index}`}
              colorStatus={highlightCellFromStatus(item)}
            >
              <td>{item.transactionId || ''}</td>
              <td>
                {currency(item.amount, {
                  symbol: currencyNameToSymbol(item.currency)
                }).format()}
              </td>
              <td>{translatePayMethod(item.paymentMethod)}</td>
              <td>
                <span>{dateWithTimezone(item.createdDateTime, 'DD.MM.YYYY')}</span>
                <styles.TimeLine>{dateWithTimezone(item.createdDateTime)}</styles.TimeLine>
              </td>
              <td>{translateTransactionStatus(item)}</td>
            </styles.BodyRow>
          ))}
        </tbody>
      </styles.Table>
    ) : (
      <PaymentsEmptyTab i18n={i18n} />
    );
  }
}

export default PaymentsTab;
